/*
 * IMPORTS
 */
import React from 'react' // NPM: React.js library.
import Head from 'next/head' // NPM: Next.js header utility.
import Dynamic from 'next/dynamic' // NPM: Next.js dynamic component utility.


/*
 * PACKAGES
 */
import GradientStripe from '~packages/lib/Gradient'


/*
 * COMPONENTS
 */
const Navbar = Dynamic(() => import('~packages/common/container/Navbar'), { 'loading': Object.Next.Dynamic.Loading })
const Footer = Dynamic(() => import('~packages/common/container/Footer'), { 'loading': Object.Next.Dynamic.Loading })
const ContactBanner = Dynamic(() => import('~packages/common/container/ContactBanner'), { 'loading': Object.Next.Dynamic.Loading })
const ContactAddress = Dynamic(() => import('~packages/common/container/ContactAddress'), { 'loading': Object.Next.Dynamic.Loading })
const GetInTouch = Dynamic(() => import('~packages/common/container/GetInTouch'), { 'loading': Object.Next.Dynamic.Loading })
const GlobalFooter = Dynamic(() => import('~packages/common/container/GlobalFooter'), { 'loading': Object.Next.Dynamic.Loading })


/*
 * OBJECTS
 */
const Index = ({ container }) => {
  // Event handler.
  React.useEffect(() => {
    // Initialize gradient.
    new GradientStripe({ 'seed': 33 }).initGradient('#ContactBannerGradient')
  })

  // Return Component.
  return (
    <section style={container}>
      <Head>
        <title>Rootandleaves - Best Web Development Company in Gurgaon</title>
        <meta name='Description' content='Home | Rootandleaves Webservices' />
      </Head>
      <div className='gradientWrapper topLeft round'>
        <canvas id='ContactBannerGradient' className='gradient color theme switch' />
        <div className='overlay' />
        <Navbar />
        <ContactBanner />
        <ContactAddress />
      </div>
      <GetInTouch />
      <Footer />
      <GlobalFooter />
    </section>
  )
}


/*
 * PROPTYPES
 */
Index.defaultProps = {
  'container': {
    'overflowX': 'hidden'
  }
}


/*
 * EXPORTS
 */
export default Index
